module.exports = __webpack_public_path__ + "img/Weapon_03.17c90a26.png";